import { Skeleton } from '@/shared/components/ui/skeleton';

export const MyProfileEditSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 pb-5">
      <Skeleton className="mb-4 h-6 w-3/4" />

      <div className="flex flex-col items-start gap-4">
        <Skeleton className="size-24 rounded-2xl" />
        <Skeleton className="h-8 w-1/3" />
      </div>

      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-16 w-full rounded-2xl" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-1/4" />
          <Skeleton className="h-4 w-1/5 rounded-full" />
        </div>
        <Skeleton className="h-24 w-full rounded-lg" />
      </div>

      {Array.from({ length: 11 }).map((_, index) => (
        <div
          key={`skeleton-field-${index.toString()}`}
          className="flex w-full items-center justify-between"
        >
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-6 w-1/3" />
            <Skeleton className="h-4 w-1/4" />
          </div>
        </div>
      ))}
    </div>
  );
};
